// kept for backward compatibility
// eslint-disable-next-line no-unused-vars
import tracer from './observability';

export default tracer;
